// Resolve the display colors for a project-association tag from a project's
// assigned theme color. Projects (rooms/buildings) get a randomly assigned
// `themeColor` (e.g. "#3b5bdb"); we tint it for the tag background and use the
// full color for the text/icon. Falls back to the default blue tag when no
// color is available.

const DEFAULT_TAG = { bg: "#eef2ff", fg: "#3b5bdb" };

const SIX_HEX = /^#([0-9a-fA-F]{6})$/;
const THREE_HEX = /^#([0-9a-fA-F]{3})$/;

function normalizeHex(color) {
  if (!color || typeof color !== "string") return null;
  const hex = color.trim();
  if (SIX_HEX.test(hex)) return hex.toLowerCase();
  if (THREE_HEX.test(hex)) {
    // Expand #abc → #aabbcc so we can append an alpha byte.
    const m = hex.slice(1);
    return ("#" + m[0] + m[0] + m[1] + m[1] + m[2] + m[2]).toLowerCase();
  }
  return null;
}

/**
 * @param {string|null|undefined} color a project themeColor like "#RRGGBB"
 * @returns {{ bg: string, fg: string }}
 */
export function getProjectTagColors(color) {
  const hex = normalizeHex(color);
  if (!hex) return DEFAULT_TAG;
  // ~13% opacity background tint of the theme color.
  return { bg: `${hex}22`, fg: hex };
}

export default getProjectTagColors;
